/**
 * Tab Component
 *
 * @file tab.js
 */

import { Fancybox } from "@fancyapps/ui";

const tabs = (() => {
  /**
   * Default Tab
   * Project default tab style
   */
  const defaultTab = () => {
    const tabsBtns = document.querySelectorAll(".a-tab-item");
    const tabsContents = document.querySelectorAll(".a-tab-content");


    for (let i = 0; i < tabsBtns.length; i += 1) {
      tabsBtns[i].addEventListener('click', function (event) {
        [].forEach.call(tabsBtns, function (el) {
          el.classList.remove('active');
        });
        tabsBtns[i].classList.toggle("active");
        [].forEach.call(tabsContents, function (el) {
          el.classList.remove('tab-active');
        });
        tabsContents[i].classList.toggle("tab-active");
        event.preventDefault();
      });
    }
  };

  const modalTab = () => {
    const loginPopBtn = document.querySelectorAll('[data-modal-tab]');
    const modalContainers = document.querySelectorAll('.dt-popup-tab-modal');
    const modalRegistry = new Map();

    if (!modalContainers.length) {
      return;
    }

    modalContainers.forEach((modalEl) => {
      const tabItems = modalEl.querySelectorAll('.default-tab-item');
      const tabContents = modalEl.querySelectorAll('.default-tab-content');

      if (!tabItems.length || !tabContents.length) {
        return;
      }

      const detectedIndex = [...tabItems].findIndex((tab) => tab.classList.contains('active'));
      const initialIndex = detectedIndex >= 0 ? detectedIndex : 0;

      const setActiveTab = (targetIndex = initialIndex) => {
        const maxIndex = Math.min(tabItems.length, tabContents.length) - 1;
        const safeIndex = Math.max(0, Math.min(targetIndex, maxIndex));

        tabItems.forEach((tab, idx) => {
          tab.classList.toggle('active', idx === safeIndex);
        });

        tabContents.forEach((section, idx) => {
          section.classList.toggle('active', idx === safeIndex);
        });
      };

      setActiveTab(initialIndex);

      tabItems.forEach((tab, idx) => {
        tab.addEventListener('click', (event) => {
          event.preventDefault();
          setActiveTab(idx);
        });
      });

      modalRegistry.set(modalEl, { setActiveTab, initialIndex });

      if (modalEl.id) {
        modalRegistry.set(`#${modalEl.id}`, { setActiveTab, initialIndex });
      }
    });

    const setModalTabFromTrigger = (triggerEl) => {
      const modalSelector = triggerEl.getAttribute('data-src') || triggerEl.getAttribute('href');
      const modalTabIndex = Number(triggerEl.getAttribute('data-modal-tab')) || 0;

      if (!modalSelector) {
        return;
      }

      const targetModal = document.querySelector(modalSelector);
      const modalEntry =
        modalRegistry.get(modalSelector) ||
        (targetModal ? modalRegistry.get(targetModal) : null);

      if (modalEntry) {
        modalEntry.setActiveTab(modalTabIndex);
      }
    };

    loginPopBtn.forEach((btn) => {
      btn.addEventListener('click', () => setModalTabFromTrigger(btn));
    });

    if (Fancybox && typeof Fancybox.on === 'function') {
      Fancybox.on('close', (fancybox) => {
        fancybox?.items?.forEach((item) => {
          if (!item?.src) {
            return;
          }

          const targetModal = document.querySelector(item.src);
          const modalEntry =
            modalRegistry.get(item.src) ||
            (targetModal ? modalRegistry.get(targetModal) : null);

          if (modalEntry) {
            modalEntry.setActiveTab(modalEntry.initialIndex || 0);
          }
        });
      });
    }
  };

  const init = () => {
    defaultTab();
    modalTab();
  };

  return {
    init,
  };
})();

export default tabs;
